const TOKEN_KEY = 'poolmanager.token';
export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}
function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}
export class UnauthorizedError extends Error {
}
async function request(path, init) {
    const token = getToken();
    const headers = { ...init?.headers };
    if (init?.body)
        headers['Content-Type'] = 'application/json';
    if (token)
        headers['Authorization'] = `Bearer ${token}`;
    const res = await fetch(path, { ...init, headers });
    if (res.status === 401) {
        clearToken();
        throw new UnauthorizedError('Sitzung abgelaufen, bitte erneut anmelden.');
    }
    // Sliding Refresh: die API liefert bei älteren Tokens einen frischen mit
    const refreshed = res.headers.get('X-Refreshed-Token');
    if (refreshed)
        setToken(refreshed);
    if (!res.ok) {
        const raw = await res.text().catch(() => '');
        let message = raw;
        try {
            const parsed = JSON.parse(raw);
            if (typeof parsed === 'string') {
                message = parsed;
            }
            else if (parsed && typeof parsed === 'object') {
                // ProblemDetails (RFC 9457) vom globalen Exception-Handler
                const pd = parsed;
                message = pd.detail ?? pd.title ?? raw;
            }
        }
        catch {
            // raw war kein JSON (z. B. leerer Body) - unverändert verwenden
        }
        throw new Error(message || `Anfrage fehlgeschlagen (${res.status})`);
    }
    if (res.status === 204)
        return undefined;
    return (await res.json());
}
export const authApi = {
    async login(username, password) {
        const res = await request('/api/auth/login', {
            method: 'POST',
            body: JSON.stringify({ username, password })
        });
        setToken(res.token);
        return res.token;
    },
    async changePassword(currentPassword, newPassword) {
        // Der Wechsel invalidiert alle alten Tokens; der Server liefert einen frischen mit
        const res = await request('/api/auth/password', {
            method: 'PUT',
            body: JSON.stringify({ currentPassword, newPassword })
        });
        setToken(res.token);
    },
    logout() {
        clearToken();
    }
};
export const measurementsApi = {
    list: () => request('/api/measurements'),
    create: (m) => request('/api/measurements', { method: 'POST', body: JSON.stringify(m) }),
    update: (id, m) => request(`/api/measurements/${id}`, { method: 'PUT', body: JSON.stringify(m) }),
    remove: (id) => request(`/api/measurements/${id}`, { method: 'DELETE' })
};
export const careEntriesApi = {
    list: () => request('/api/care-entries'),
    create: (c) => request('/api/care-entries', { method: 'POST', body: JSON.stringify(c) }),
    update: (id, c) => request(`/api/care-entries/${id}`, { method: 'PUT', body: JSON.stringify(c) }),
    remove: (id) => request(`/api/care-entries/${id}`, { method: 'DELETE' })
};
export const testDataApi = {
    seed: () => request('/api/test-data/seed', { method: 'POST' }),
    clear: () => request('/api/test-data', { method: 'DELETE' })
};
export const importApi = {
    // Ersetzt alle Messungen und Pflege-Einträge transaktional (CSV-Import aus den Einstellungen)
    replaceAll: (data) => request('/api/data/import', {
        method: 'POST',
        body: JSON.stringify(data)
    })
};
export const settingsApi = {
    get: () => request('/api/settings'),
    update: (s) => request('/api/settings', { method: 'PUT', body: JSON.stringify(s) })
};
